import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';

import { ProductDetails } from './details/product-details.model';

import { CatalogService } from '../catalogs/catalog.service';
@Injectable()
export class ProductsService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService,
        private catalogService: CatalogService
    ) { }


    delete(details: any): Observable<ProductDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.products.delete.api;
        return this.requestService.post(url, details);
    }

    getProductDetails(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.products.details.api + '/' + id;
        return this.requestService.get(url);
    }

    edit(details: any) {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.products.edit.api;
        return this.requestService.post(url, details);
    }

    add(details: any) {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.products.add.api;
        return this.requestService.post(url, details);
    }

    formatData(details: any) {
        const obj = {
            domains: details.domains ? details.domains.map(_ => {return { id: _ }}) : [],
            categoryFamily: details.categoryFamily ? details.categoryFamily.map(_ => {return { id: _ }}) : []
        };
        const keywords = details.keywords ? details.keywords : null;
        const subTopics = details.subTopics ? details.subTopics.map(el => {return { 'id': el}} ) : [];
        const brand = details.brand ? { 'id': details.brand} : null;
        const category = details.category ? { 'id': details.category} : {};
        details['subTopics'] = subTopics;
        details['brand'] = brand;
        details['category'] = category;
        details['keywords'] = keywords;
        let result = Object.assign({}, details);
        result = Object.assign(result, obj);
        return result;
    }

    bulkEdit(details: any) {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.products.bulkEdit.api;
        return this.requestService.post(url, details);
    }

    getDomainDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productDomain.api;
        return this.requestService.get(url);
    }

    getCategoryFamilyDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productCategoryFamily.api;
        return this.requestService.get(url);
    }

    getTypeDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productType.api;
        return this.requestService.get(url);
    }

    getLevelDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productLevel.api;
        return this.requestService.get(url);
    }

    getGroupDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.dictionaryPerDomain.api;
        return this.requestService.get(url);
    }

    getDiscountCategoryDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productDiscountCategory.api;
        return this.requestService.get(url);
    }

    getProductSegmentDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productSegment.api;
        return this.requestService.get(url);
    }

    getProductExamFulfillmentDict(): Observable<any> {
        let url = this.configService.get('server').url + '/api/product/exam/fulfilment'; // Dummy API
        return this.requestService.get(url);
    }

    getBulkActions(): any {
        return {
            key: 'id',
            actions: [
                { name: 'edit', label: 'Edit', icon: 'fa-pencil-square', show: (data) => data.length > 0 }
            ]
        };
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/products/products.service.ts